import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowCabinet from '../components/cabinets/ShowCabinet'

const Cabinets:React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Cabinets")}</h1>
      <ShowCabinet />
    </div>
  )
}

export default Cabinets
